export class BaggingList {
  purchaseOrderItemBaggingIds: number[] = [];
}
